import { useMemo } from 'react';

import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { createBaseBarcode, createScanAndPayBarcode, getForterToken } from '../utils/barcode-utils';

/**
 * useFormatLoyaltyBarcode handles logic for creating
 *  the string used for generating the TH loyalty QR code.
 *
 * IF scan & pay enabled -> appends additional values for S&P
 * IF scan & pay disabled -> returns default barcode string
 */
export const useFormatLoyaltyBarcode = () => {
  const { user } = useAuthContext();
  const enableTHScanAndPay = useFlag(LaunchDarklyFlag.ENABLE_TH_SCAN_AND_PAY);
  const { activeCard, loyaltyDetails } = useLoyaltyActiveCard();
  const baseBarcode = createBaseBarcode(activeCard?.barcode);
  const scanAndPayEnabledForUser = loyaltyDetails?.scanAndPay ?? false;

  // CTG required add-ons when scan & pay enabled
  const userId = user?.cognitoId;
  const scanAndPayPaymentMethodId = user?.details?.defaultScanAndPayAccountIdentifier;
  const forterToken = getForterToken();

  const scanAndPayBarcode = useMemo(() => {
    return createScanAndPayBarcode({
      baseBarcode,
      forterToken,
      paymentMethodId: scanAndPayPaymentMethodId,
      userId,
    });
  }, [baseBarcode, forterToken, scanAndPayPaymentMethodId, userId]);

  // if scan & pay disabled or not on,
  // no need for the additional values
  if (!enableTHScanAndPay || !scanAndPayEnabledForUser) {
    return baseBarcode;
  }

  return scanAndPayBarcode;
};
